import { render, staticRenderFns } from "./studentList.vue?vue&type=template&id=0c6c0472&scoped=true&"
import script from "./studentList.vue?vue&type=script&lang=js&"
export * from "./studentList.vue?vue&type=script&lang=js&"
import style0 from "./studentList.vue?vue&type=style&index=0&id=0c6c0472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6c0472",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c6c0472')) {
      api.createRecord('0c6c0472', component.options)
    } else {
      api.reload('0c6c0472', component.options)
    }
    module.hot.accept("./studentList.vue?vue&type=template&id=0c6c0472&scoped=true&", function () {
      api.rerender('0c6c0472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom1/components/studentList.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/studentList.vue
// module id = XTRz
// module chunks = 0